module.exports = __webpack_public_path__ + "img/click-seal.da48bd5e.gif";